<template>
  <font-awesome-icon
    v-if="name === 'Facebook'"
    icon="fa-brands fa-facebook"
    class="text-ocean"
  />
  <font-awesome-icon
    v-if="name === 'Linkedin'"
    icon="fa-brands fa-linkedin-in"
    class="text-ocean"
  />
  <font-awesome-icon
    v-else-if="name === 'Twitter'"
    icon="fa-brands fa-x-twitter"
    class="text-ocean"
  />
  <font-awesome-icon
    v-else-if="name === 'Instagram'"
    icon="fa-brands fa-instagram"
    class="text-ocean"
  />
  <font-awesome-icon
    v-else-if="name === 'Youtube'"
    icon="fa-brands fa-youtube"
    class="text-ocean"
  />
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
